
class KeyboardManager extends PIXI.utils.EventEmitter {
    public isEnabled: boolean;
    protected _pressedKeys: boolean[];
    protected _releasedKeys: boolean[];
    protected _downKeys: boolean[];
    protected _preventDefaultKeys: boolean[];

    constructor(){
        super();
        this.isEnabled = false;
        this._pressedKeys = [];
        this._releasedKeys = [];
        this._downKeys = [];

        this._preventDefaultKeys = [];
        this.enable();
    }

    public enable(){
        if(!this.isEnabled){
            this.isEnabled = true;
            this._enableEvents();
        }
    }

    protected _enableEvents(){
        window.addEventListener('keydown', this._onKeyDown.bind(this), true);
        window.addEventListener('keyup', this._onKeyUp.bind(this), true);
    }

    public disable(){
        if(this.isEnabled){
            this.isEnabled = false;
            this._disableEvents();
        }
    }

    protected _disableEvents() {
        window.removeEventListener('keydown', this._onKeyDown, true);
        window.removeEventListener('keyup', this._onKeyUp, true);
    }

    public setPreventDefault(key, value = true){
        if(Array.isArray(key)){
            for(let i = 0; i < key.length; i++){
            this._preventDefaultKeys[key[i]] = value;
            }
        }else{
            this._preventDefaultKeys[key] = value;
        }
    }

    protected _onKeyDown(evt){
        if (this.isEnabled) {
            let key = evt.which || evt.keyCode;
            if(this._preventDefaultKeys[key]){
                evt.preventDefault();
            }

            if(!this.isDown(key)){
                this._downKeys.push(key);
                this._pressedKeys[key] = true;
                this.emit('pressed_' + key);
            }
        }
    }

    protected _onKeyUp(evt){
        if (this.isEnabled) {
            let key = evt.which || evt.keyCode;
            if(this._preventDefaultKeys[key]){
                evt.preventDefault();
            }

            if(this.isDown(key)){
                this._pressedKeys[key] = false;
                this._releasedKeys[key] = true;

                let _index = this._downKeys.indexOf(key);
                if(_index !== -1)this._downKeys.splice(_index, 1);
                this.emit('released_' + key);
            }
        }
    }

    public isDown(key){
        return (this._downKeys.indexOf(key) !== -1);
    }

    public isPressed(key){
        return !!this._pressedKeys[key];
    }

    public isReleased(key){
        return !!this._releasedKeys[key];
    }

    public onKey(event: string, key: number, fn: () => any, context?) {
        super.on(`${event}_${key}`,fn,context);
    }

    public offKey(event: string, key: number, fn: () => any, context?) {
        super.off(`${event}_${key}`,fn,context);
    }

}
export default new KeyboardManager();

export const Key = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    PAUSE: 19,
    CTRL: 17,
    ALT: 18,
    CAPS_LOCK: 20,
    ESCAPE: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    PRINT_SCREEN: 44,
    INSERT: 45,
    DELETE: 46,
    _0: 48,
    _1: 49,
    _2: 50,
    _3: 51,
    _4: 52,
    _5: 53,
    _6: 54,
    _7: 55,
    _8: 56,
    _9: 57,
    A: 65,
    B: 66,
    C: 67,
    D: 68,
    E: 69,
    F: 70,
    G: 71,
    H: 72,
    I: 73,
    J: 74,
    K: 75,
    L: 76,
    M: 77,
    N: 78,
    O: 79,
    P: 80,
    Q: 81,
    R: 82,
    S: 83,
    T: 84,
    U: 85,
    V: 86,
    W: 87,
    X: 88,
    Y: 89,
    Z: 90,
    CMD: 91,
    CMD_RIGHT: 93,
    NUM_0: 96,
    NUM_1: 97,
    NUM_2: 98,
    NUM_3: 99,
    NUM_4: 100,
    NUM_5: 101,
    NUM_6: 102,
    NUM_7: 103,
    NUM_8: 104,
    NUM_9: 105,
    MULTIPLY: 106,
    ADD: 107,
    SUBTRACT: 109,
    DECIMAL_POINT: 110,
    DIVIDE: 111,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    NUM_LOCK: 144,
    SCROLL_LOCK: 145,
    SEMI_COLON: 186,
    EQUAL: 187,
    COMMA: 188,
    DASH: 189,
    PERIOD: 190,
    FORWARD_SLASH: 191,
    OPEN_BRACKET: 219,
    BACK_SLASH: 220,
    CLOSE_BRACKET: 221,
    SINGLE_QUOTE: 222
};
